<!-- auth-side-panel.component.html -->
<div class="min-h-screen bg-[#1a2b5c] flex flex-col p-12 text-white">

    <!-- Logo at top -->
    <div class="flex justify-center mb-8">
        <img class="h-14 w-auto" src="/assets/images/logo-white.svg" alt="SalesOMMO">
    </div>

    <!-- Main Content - Takes up the middle space -->
    <div class="flex-1 flex flex-col justify-center items-center text-center">
        <div class="max-w-2xl mx-auto space-y-8">
            <h1 class="text-5xl font-bold leading-tight">
                Prospect with high <span class="text-orange-400">precision</span>,
                qualify <span class="text-orange-400">fast</span>, personalize and
                act <span class="text-orange-400">smarter</span>.
            </h1>

            <p class="text-lg text-gray-200">
                Get our instant <span class="text-orange-400 font-semibold">Executive Brief</span>
                with data and insights, and the <span class="text-orange-400 font-semibold">ICP Score</span>. <br />
                Qualify and focus on top customers, personalize with speed, and get an edge by
                acting smarter.
            </p>

            <div class="mt-8">
                <a href="https://salesommo.com" target="_blank" class="bg-orange-500 hover:opacity-90 text-white font-semibold py-3 px-8 rounded-lg transition-colors">
                    See what SalesOMMO can do
                </a>
            </div>
        </div>
    </div>

    <!-- Footer at bottom -->
    <div class="flex flex-col items-center space-y-4 text-center mt-8">
        <div class="mb-8">
            <p class="font-semibold">We're here for you</p>
            <p class="text-gray-100 mb-2">Have a question or feedback?</p>
            <a href="https://salesommo.com/contact" target="_blank" class="text-white hover:hover:opacity-90 transition-colors">
                Contact us
            </a>
        </div>

        <div class="flex gap-6 text-sm text-white">
            <a href="https://salesommo.com/privacy-policy" target="_blank" class="hover:opacity-90 transition-colors">Privacy Policy</a>
            <a href="https://salesommo.com/cookie-policy" target="_blank" class="hover:opacity-90 transition-colors">Cookie Policy</a>
        </div>
    </div>
</div>
